module.exports = __webpack_public_path__ + "static/media/mama-burger-combo-mobile-fr.ac574c17.jpg";